import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { CacheService } from '../cache.service';
import { CourseService } from '../course.service';
import { CourseVendorsService } from '../course-vendors.service';
import { FileUploadService } from '../file-upload.service';
import { CourseVendor } from '../course-vendor.model';
import { SessionMap } from '../session-map.model';


@Component({
selector: 'app-course-vendor',
templateUrl: './course-vendor.component.html',
styleUrls: ['./course-vendor.component.scss']
})
export class CourseVendorComponent implements OnInit {
    @Input() courseVendor: CourseVendor;
    // @Output() cancelAdd = new EventEmitter<boolean>();

    form;
    isAdd: boolean;
    isLoading: boolean = false;
    isLoaded: boolean = false;
    isSubmitted: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    // isValid: boolean = false;
    isEditable: boolean = false;
    loadingError: string = '';
    loadingMsg: string = '';
    errorMessage: string = '';
    display: boolean = false;
    // display: boolean = true;

    a2eOptions = {
        format: 'MM/DD/YYYY hh:mm:ss A',
        showClear: true,
        showClose: true,
    };

    constructor(
        private apiService: ApiService,
        private cacheService: CacheService,
        private courseService: CourseService,
        private courseVendorsService: CourseVendorsService,
        private fileUploadService: FileUploadService,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.isAdd = !this.courseVendor;
        if (this.isAdd) {
            this.courseVendor = new CourseVendor({});
            this.isEditable = true;
            this.isLoaded = true;
            this.display = true;
        }
        this.prepareForm();
    }

    prepareForm() {
        this.form = this.fb.group({
            id: [this.courseVendor.id, []],
            status: [this.courseVendor.status, [Validators.required]],
            joinUrl: [this.courseVendor.joinUrl, [Validators.maxLength(400)]],
            docebo: [this.courseVendor.docebo.status, []],
            doceboShowOpen: [this.courseVendor.docebo.showOpen, []],
            zoom: [this.courseVendor.zoom.status, []],
            zoomShowOpen: [this.courseVendor.zoom.showOpen, []],
            sortOrder: [this.courseVendor.sortOrder, []],
            videoUrl: [this.courseVendor.videoUrl, [Validators.maxLength(400)]],

            // vendor entity; could separate ui and select from a drop down of pre-existing vendors
            name: [this.vendor.name, [Validators.required, Validators.maxLength(300)]],
            description: [this.vendor.description, [Validators.maxLength(4000)]],
            address: [this.vendor.address, [Validators.maxLength(100)]],
            city: [this.vendor.city, [Validators.maxLength(100)]],
            state: [this.vendor.state, [Validators.maxLength(10)]],
            zip: [this.vendor.zip, [Validators.maxLength(10)]],
            email: [this.vendor.email, [Validators.maxLength(100)]],
            phone: [this.vendor.phone, [Validators.maxLength(10)]],
            facebook: [this.vendor.facebook, [Validators.maxLength(100)]],
            twitter: [this.vendor.twitter, [Validators.maxLength(100)]],
            youtube: [this.vendor.youtube, [Validators.maxLength(100)]],
            website: [this.vendor.website, [Validators.maxLength(100)]],
            // logo: using service to add logo file data...could add file upload form input here with more time to explore
        });

        // this.form.valueChanges.subscribe((value) => {
        //     this.isValid = this.form.dirty && !this.form.invalid;
        // });
    }

    get() {
        if (this.isLoading) return;

        this.isEditable = false;
        this.isSaving = false;
        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getCourseVendor(this.course, this.courseVendor).subscribe(
            (data) => {
                this.courseVendor = new CourseVendor(data);
                this.fileUploadService.image = this.courseVendor.vendor.logo;
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }

    collapse() {
        if (this.isEditable) return;
        if (!this.isLoaded) this.get();
        this.display = !this.display;
    }

    edit() {
        this.prepareForm();
        this.isEditable = true;
        this.courseVendorsService.isEditable = true;
    }

    cancel() {
        this.errorMessage = '';
        this.isEditable = false;
        this.courseVendorsService.isEditable = false;
        this.courseVendorsService.isAdd = false;
        this.form.reset(this.vendor);
    }

    save() {
        this.isSubmitted = true;
        if ( this.form.dirty && this.form.invalid ) return;
        if ( !this.form.dirty && !this.fileUploadService.dirty ) return;
        if ( this.isSaving) return;
        this.isSaving = true;
        this.errorMessage = ``;

        this.form.value.logo = this.fileUploadService.file ? this.fileUploadService.file : this.fileUploadService.image;

        if (!this.isAdd) {
            this.apiService
                .updateCourseVendor(this.course, this.form.value)
                .subscribe(
                    (data) => {
                        this.courseVendorsService.isAdd = false;
                        this.courseVendorsService.isEditable = false;
                        this.courseVendorsService.get();
                    },
                    (error) => {
                        this.errorMessage = error;
                        this.isSaving = false;
                    }
                );
            return;
        }

        this.apiService
            .createCourseVendor(this.course, this.form.value)
            .subscribe(
                (data) => {
                    this.courseVendorsService.isAdd = false;
                    this.courseVendorsService.isEditable = false;
                    this.courseVendorsService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isSaving = false;
                }
            );
    }

    delete() {
        if ( this.isDeleting) return;
        if ( !confirm(`Are you sure you would like to remove this Vendor from this Course?`) ) return;
        this.isDeleting = true;
        this.errorMessage = ``;

        this.apiService
            .deleteCourseVendor(this.course, this.courseVendor)
            .subscribe(
                (data) => {
                    this.isDeleting = false;
                    this.courseVendorsService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isDeleting = false;
                }
            );
    }
    
    open(url){
        window.open(url, "_blank");
    }

    openDocebo(){
        window.open(`/dashboard/lms/${this.courseVendor.docebo.id}`, "_blank");
    }

    openZoom(){
        console.log(`open zoom`)
        // window.open(`/dashboard/lms/${this.vendor.integrations.zoom.applicationId}`, "_blank");
    }

    get vendor() {
        return this.courseVendor.vendor;
    }

    get statuses() {
        return this.cacheService.active;
    }

    get yesNo() {
        return this.cacheService.yesNo;
    }

    get course() {
        return this.courseService.course;
    }

    get name() {
        return this.form.get('name');
    }

    get status() {
        return this.form.get('status');
    }

    get description() {
        return this.form.get('description');
    }
    
    get address() {
        return this.form.get('address');
    }

    get city() {
        return this.form.get('city');
    }

    get state() {
        return this.form.get('state');
    }

    get zip() {
        return this.form.get('zip');
    }

    get email() {
        return this.form.get('email');
    }

    get phone() {
        return this.form.get('phone');
    }
    
    get facebook() {
       return this.form.get('facebook'); 
    }

    get twitter() {
       return this.form.get('twitter'); 
    }

    get youtube() {
       return this.form.get('youtube'); 
    }

    get joinUrl() {
        return this.form.get('joinUrl');
    }
    
    get docebo() {
        return this.form.get('docebo');
    }

    get doceboShowOpen() {
        return this.form.get('doceboShowOpen');
    }

    get zoom() {
        return this.form.get('zoom');
    }
    
    get zoomShowOpen() {
        return this.form.get('zoomShowOpen');
    }
    
    get sortOrder() {
        return this.form.get('sortOrder');
    }

    get website() {
        return this.form.get('website');
    }

    get videoUrl() {
        return this.form.get('videoUrl');
    }
}
